import React, { Component } from "react";
// import AccountDataService from "../services/account-activities";
// import { Redirect } from "react-router-dom";

import { connect } from 'react-redux';
// import { ACCESSTOKEN } from '../features/actions/Is-Logged-Actions';
// import { UPDATE_ACTIVE_LINK } from '../features/actions/Active-Nav-Link-Actions';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Navbar from '../../components/Navbar';
/* import {
    Paper,
    Button,
} from '@mantine/core'; */

//import Card from 'react-bootstrap/Card';

//import {Link} from 'react-router-dom';

//import ListGroup from 'react-bootstrap/ListGroup';

import { Redirect } from 'react-router';

import HardwareAssetDataService from '../../services/hardware-asset-activities';

import { LOGOUT } from '../../features/actions/Is-Logged-Actions';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

//import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
//import Tooltip from 'react-bootstrap/Tooltip';
//import Modal from 'react-bootstrap/Modal';

//import Card from 'react-bootstrap/Card';
//import Table from 'react-bootstrap/Table';

import Form from 'react-bootstrap/Form';

import RichTextInput from "../RichTextInput";
import { cleanHTML } from '../../html-cleaner';
import parse from 'html-react-parser';

import {
    ScrollArea,
    UnstyledButton,
    Group,
    Text,
    Center,
    TextInput,
    Button,
    Switch,
    Table,
    rem,
    keys,
    Paper,
    Space,
    Select,
    Modal,
    Grid,
    Flex,
    MultiSelect,
    HoverCard,
    Textarea,
    Alert,
    Collapse,
    Title,
    Divider,
    List,
    Anchor
} from '@mantine/core';

import classes from '../Hardware-Ticket-Details.module.css';

import { IconEdit, IconPlus, IconChevronDown, IconChevronUp } from "@tabler/icons-react";
//import classes from './Hardware-Ticket-Details.module.css';
//import {Link} from 'react-router-dom';
//import ListGroup from 'react-bootstrap/ListGroup';


class HardwareAssetDetails extends Component {

    // this.props.match.params.id => to get id number from the URL
    constructor(props) {
        super(props);

        // function registrations
        this.getAssetDetails = this.getAssetDetails.bind(this);
        this.calculateWarrantyLeaseDaysRemaining = this.calculateWarrantyLeaseDaysRemaining.bind(this);
        this.getHistoryDetails = this.getHistoryDetails.bind(this);

        this.closeHistoryNoteModal = this.closeHistoryNoteModal.bind(this);
        this.openHistoryNoteModal = this.openHistoryNoteModal.bind(this);
        this.handleCreateHistoryNoteTextChange = this.handleCreateHistoryNoteTextChange.bind(this);
        this.handleSelectedEventTypeChange = this.handleSelectedEventTypeChange.bind(this);
        this.submitCreateHistoryNoteForm = this.submitCreateHistoryNoteForm.bind(this);

        this.closeHistoryNoteDetailsModal = this.closeHistoryNoteDetailsModal.bind(this);
        this.openHistoryNoteDetailsModal = this.openHistoryNoteDetailsModal.bind(this);

        this.goToEditPage = this.goToEditPage.bind(this);

        this.state = {
            asset: {
                id: 0,
                asset_type_id: 0,
                asset_type_name: "",
                name_of_asset: "",
                model_id: 0,
                model_name: "",
                vendor_id: 0,
                vendor_name: "",
                asset_tag: "",
                asset_serial_number: "",
                ip_address: "",
                mac_address: "",
                ram: "",
                cpu: "",
                asset_bar_code: "",
                acquisition_date: "",
                warranty_start_date: "",
                warranty_expiration_date: "",
                site_id: 0,
                name_of_site: "",
                assigned_person_id: 0,
                //assigned_person_name: "",
                first_name: "",     // the names refer to the name of the person assigned this asset
                middle_name: "",
                last_name: "",
                assigned_location_at_site_id: 0,
                //assigned_location_at_site_text: "",
                floor_number: "",
                aisle_number: "",
                desk_number: "",
                lease_start_date: "",
                lease_end_date: "",
                manufacturer_website: "",
                asset_category_id: 0,
                asset_category_name: "",
                isTracked: false,
                core_asset_assigned_to_id: 0,
                core_asset_assigned_to_name: "",
                tenant_id: 0,
                tenant_name: ""
            },

            attachments: [],

            installed_software: [],

            notes: [],

            show_notes_modal: false,
            asset_note_text_input: "",
            showSaving: false,

            warranty_days_remaining: null,
            lease_days_remaining: null,

            history: [],     // constains history items for that asset

            show_history_note_modal: false,
            history_note_text_entered: "",
            canSeeErrorMessageCreateHistoryNote: false,
            eventTypes: [       // a curated list of types that the history entities will accept - used in drop down on modal
                {event_type_name: "Assignment"},
                {event_type_name: "Creation"},
                {event_type_name: "Lease Update"},
                {event_type_name: "Location Change"},
                {event_type_name: "Reassignment"},
                {event_type_name: "Software Deployment"},
                {event_type_name: "Ticket Created"},
                {event_type_name: "Warranty Update"}
            ],
            selected_event_type_name: "",    // controls which name is sent to backend upon creation 


            show_history_note_details_modal: false,  // set to true if user clicks a speciifc note in history table
            note_details: {},

            // control the collapses on the page
            basicInfoSection: true,
            assignmentsSection: false,
            identifyingDetailsSection: false,
            purchaseInfoSection: false,
            servicesSection: false,
            cloudSection: false,
            virtualMachineSection: false,
            volumeSection: false,
            hostSection: false,
            datacenterSection: false,
            datastoreSection: false,
            imageSection: false,
            loadBalancerSection: false,
            securityGroupSection: false,
            networkSection: false,
            resourcePoolSection: false,
            networkInterfaceSection: false,
            publicIPAddressSection: false,
            vpcSection: false,
            subnetSection: false,
            databaseSection: false,
            keyPairSection: false,
            objectStorageSection: false,
            keyVaultSection: false,
            subscriptionSection: false,
            resourceGroupSection: false,
            applicationGatewaySection: false,
            hardwareSection: false,
            costSection: false,
            computerSection: false,
            diskSection: false,
            rackSection: false,
            upsSection: false,
            mobileDevicesSection: false,
            printerSection: false,
            routerSection: false,
            switchSection: false,
            accessPointSection: false,
            firewallSection: false,
            snmpSection: false,
            consumableSection: false,
            documentSection: false,
            warrantyLeaseAndMaintenanceSection: false,
            miscSection: false,
            attachmentsSection: false,
            installedSoftwareSection: false,
            notesSection: true,
        }

    }

    toggleSection = (sectionName) => {
        this.setState((prevState) => ({
          [sectionName]: !prevState[sectionName],
        }));
    };

    goToEditPage() {
        this.props.history.push(`/editHardwareAsset/${this.props.match.params.id}`);  
    }

    openAssetNotesModal() {
        console.log("Open modal clicked!");
        this.setState({
            asset_note_text_input: "",
            show_notes_modal: true
        }); 
    }

    closeAssetNotesModal() {
        this.setState({
            asset_note_text_input: "",
            show_notes_modal: false
        });
    }

    onChangeAssetNote = (value) => {
        this.setState({
            asset_note_text_input: value
        });

    }

    closeHistoryNoteModal() {
        this.setState({
            show_history_note_modal: false,
            history_note_text_entered: ""
        });
    }

    openHistoryNoteModal() {
        this.setState({
            show_history_note_modal: true,
            selected_event_type_name: this.state.eventTypes[0].event_type_name
        });
    }

    closeHistoryNoteDetailsModal() {
        this.setState({
            show_history_note_details_modal: false
        });
    }

    openHistoryNoteDetailsModal(noteId) {
        // this.setState({
        //     show_history_note_details_modal: true
        // });

        HardwareAssetDataService.getSpecificHistoryEventDetails(noteId, this.props.loggedStatus.timezone_adjustment_factor).then(response => {
            console.log(response.data.results[0]);
            // if the record has a ticket id associated with it, navigate to that ticket details screen
            if(response.data.results[0].associated_ticket_id !== null) {
                this.props.history.push(`/hardwareTickets/${response.data.results[0].associated_ticket_id}`);
            }

            else {
                this.setState({
                    show_history_note_details_modal: true,
                    note_details: response.data.results[0]
                }, () => console.log(this.state.note_details));

            }
        })
        .catch(e => {
            console.log(e);
        });

    }

    handleCreateHistoryNoteTextChange(e) {
        this.setState({
            history_note_text_entered: e.target.value
        });
    }

    handleSelectedEventTypeChange(newName) {
        this.setState({
            selected_event_type_name: newName
        });
    }

    submitCreateHistoryNoteForm() {
        console.log("Values submitting to backend: ");
        console.log("Note Text: ", this.state.history_note_text_entered);
        console.log("Type Name; ", this.state.selected_event_type_name);

        // make sure they are submitting required fields
        if(this.state.history_note_text_entered === "" || this.state.selected_event_type_name === "") {
            this.setState({
                canSeeErrorMessageCreateHistoryNote: true
            });
        }

        else {
            this.setState({
                canSeeErrorMessageCreateHistoryNote: false
            });

            // get data ready to send to backend
            let data = {
                assetId: this.props.match.params.id,
                creatorId: this.props.loggedStatus.id, 
                //creationTime: new Date().toISOString().slice(0, 19).replace('T', ' '), 
                itemText: this.state.history_note_text_entered, 
                itemType: this.state.selected_event_type_name
            };

            HardwareAssetDataService.createHistoryEvent(data).then(response => {
                // get the updated history items list
                this.getHistoryDetails(this.props.match.params.id).then(response => {
                    this.setState({
                        history: response.results
                    });

                    this.closeHistoryNoteModal();
                })
                .catch(e => {
                    console.log(e);
                });
            })
            .catch(e => {
                console.log(e);
            });
        }
    }

    submitAssetNote() {
        //console.log("Pushed submit");
        let data = {
            noteText: this.state.asset_note_text_input,
            tenantId: this.state.asset.tenant_id,       // using the tenant of the ASSET for assignment - not the tenant of the creator
            associatedAssetId: this.state.asset.id,
            creatorId: this.props.loggedStatus.id
        };

        if(this.state.asset_note_text_input && this.state.asset_note_text_input.length > 0) {
            this.setState({
                showSaving: true,
                show_notes_modal: false
            });
            HardwareAssetDataService.createAssetNote(data).then(response => {
                // ask for the updated note information here
                this.getAssetDetails(this.props.match.params.id, this.props.loggedStatus.timezone_adjustment_factor).then(response => {
                    this.setState({
                        notes: response.asset_notes
                    }, () => {
                        // create a history event for this asset
                        let historyData = {
                            assetId: this.state.asset.id,
                            creatorId: this.props.loggedStatus.id,  
                            itemText: "Asset Note Created", 
                            itemType: "Edit"
                        };


                        HardwareAssetDataService.createHistoryEvent(historyData).then(response => {
                            this.getHistoryDetails(this.state.asset.id).then(response => {
                                this.setState({
                                    history: response.results,
                                    showSaving: false
                                }, () => this.closeAssetNotesModal());
                            })
                        })
                        .catch(e => {
                            console.log(e);
                        });

                    });
                })
                .catch(e => {
                    console.log(e);
                })
            })
            .catch(e => {
                console.log(e);
            })
        }

        else {
            console.log("No note text input");
        }
    }

    submitAssetNote() {
        //console.log("Pushed submit");
        let data = {
            noteText: this.state.asset_note_text_input,
            tenantId: this.state.asset.tenant_id,       // using the tenant of the ASSET for assignment - not the tenant of the creator
            associatedAssetId: this.state.asset.id,
            creatorId: this.props.loggedStatus.id
        };

        if(this.state.asset_note_text_input && this.state.asset_note_text_input.length > 0) {
            this.setState({
                showSaving: true,
                show_notes_modal: false
            });

            
            HardwareAssetDataService.createAssetNote( data).then(response => {
                // ask for the updated note information here
                this.getAssetDetails(this.props.match.params.id, this.props.loggedStatus.timezone_adjustment_factor).then(response => {
                    this.setState({
                        notes: response.asset_notes
                    }, () => {
                        // create a history event for this asset
                        let historyData = {
                            assetId: this.state.asset.id,
                            creatorId: this.props.loggedStatus.id,  
                            itemText: "Asset Note Created", 
                            itemType: "Edit"
                        };


                        HardwareAssetDataService.createHistoryEvent(historyData).then(response => {
                            this.getHistoryDetails(this.state.asset.id).then(response => {
                                this.setState({
                                    history: response.results,
                                    showSaving: false
                                }, () => this.closeAssetNotesModal());
                            })
                        })
                        .catch(e => {
                            console.log(e);
                        });

                    });
                })
                .catch(e => {
                    console.log(e);
                })
            })
            .catch(e => {
                console.log(e);
            })
        }
        

        else {
            console.log("No note text input");
        }
    }

    getAssetDetails(id, timezoneAdjustmentFactor) {
        return new Promise ((resolve, reject) => {
  
            HardwareAssetDataService.getSpecificAsset(id, timezoneAdjustmentFactor)
            .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                resolve(response.data);
            })
            .catch(e => {
                console.log(e);
                reject(e);
            });
        });        
    }

    calculateWarrantyLeaseDaysRemaining() {
        // if a warranty expiration date exists, calculate its distance from today. if it doesn't exist the days remaining stays null
        if(this.state.asset.warranty_expiration_date && this.state.asset.warranty_expiration_date !== null && this.state.asset.warranty_expiration_date !== "") {
            // create a date object with today's date
            var today = new Date();
            // var m = q.getMonth()+1;
            // var d = q.getDay();
            // var y = q.getFullYear();

            // var today = new Date(y,m,d);

            // compare today's date with the date of warranty expiration
            var expiration = new Date(this.state.asset.warranty_expiration_date.split("T")[0]);

            console.log(today);
            //console.log(today);
            console.log(expiration);

            // To calculate the time difference of two dates
            var Difference_In_Time = expiration.getTime() - today.getTime();
            
            // To calculate the no. of days between two dates
            var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

            //console.log("Difference in days is: ", Math.round(Difference_In_Days));

            this.setState({
                warranty_days_remaining: Math.ceil(Difference_In_Days)
            });
        }

        // if a lease expiration date exists, calculate its distance from today. if it doesn't exist the days remaining stays null
        if(this.state.asset.lease_end_date && this.state.asset.lease_end_date !== null && this.state.asset.lease_end_date !== "") {
            var todayForLease = new Date();
            var leaseExpiration = new Date(this.state.asset.lease_end_date.split("T")[0]);

            var Difference_In_Time_Lease = leaseExpiration.getTime() - todayForLease.getTime();
            var Difference_In_Days_Lease = Difference_In_Time_Lease / (1000 * 3600 * 24);

            this.setState({
                lease_days_remaining: Math.ceil(Difference_In_Days_Lease)
            });
        }
    }

    getHistoryDetails(id) {
        return new Promise ((resolve, reject) => {
  
            HardwareAssetDataService.getHistory(id, this.props.loggedStatus.timezone_adjustment_factor)
            .then(response => { // take response (next chunk of tickets) and add it to the back of the current state array
                resolve(response.data);
            })
            .catch(e => {
                console.log(e);
                reject(e);
            });
        });
    }

    componentDidMount() {
        if(this.props.loggedStatus.loggedIn) {
            console.log(new Date().toISOString().slice(0, 19).replace('T', ' '));
            this.getAssetDetails(this.props.match.params.id, this.props.loggedStatus.timezone_adjustment_factor).then(response => {
                console.log("Response from get asset details: ", response);
                this.setState({
                    asset: response.results[0],
                    attachments: response.attachments,
                    installed_software: response.installed_software,
                    notes: response.asset_notes
                }, () => this.calculateWarrantyLeaseDaysRemaining());

            this.getHistoryDetails(this.props.match.params.id).then(response => {
                this.setState({
                    history: response.results
                }, () => console.log(this.state.history));
            })
            .catch(e => {
                console.log(e);
            });
            })
            .catch(e => {
                console.log(e);
            }); 
        }
        
    }



    render() {
        if(!this.props.loggedStatus.loggedIn || (!this.props.userPermissions.can_see_assets && !this.props.userPermissions.can_edit_assets && !this.props.userPermissions.can_add_assets && !this.props.userPermissions.can_delete_assets)) {
            return (
                <Redirect to='/'/>
            );
        }

        const type = this.state.asset?.asset_type_name;


        return (
            <>
            <Navbar pageTitle={"Hardware Asset Details"} />
                <div className="container mt-3" style={{paddingTop: "15px"}}></div>
                <Container fluid display="flex">
                    <Paper withBorder p="md" radius="md" ml="20px" w="325px" style={{ float: "right" }} className={classes.showHideMiniKnowledgebase}>
                        <div style={{marginBottom: "10px"}}><Text td="underline" fw={700} ta="center">Asset History Timeline</Text></div>
                        <span className="miniKnowledgebase showHideMiniKnowledgebase">
                            {this.state.history && this.state.history.map((event, index) => (
                                <div style={{ textAlign: "center" }} key={`history_item-${event.id}`}>
                                    <div><Text size="sm" fw={600}>{event.item_text}</Text></div>
                                    <div><Text size="xs" fs="italic">{`${event.creator_first_name} ${event.creator_last_name}`}</Text></div>
                                    <div><Text size="xs" fs="italic">{event.formatted_date_time_created}</Text></div>
                                    {index === this.state.history.length - 1 ?
                                        undefined
                                        :
                                        <div style={{ paddingTop: "10px", paddingBottom: "10px", color: "blue" }}>|</div>
                                    }
                                </div>
                            ))}
                        </span>
                    </Paper>
                    
                    <Paper withBorder p="md" radius="md" m="5px" style={{ overflow: "auto" }}>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}><Button onClick={() => this.goToEditPage()}><IconEdit/></Button></div>
                        <>
                            <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('basicInfoSection')}>
                                <Title order={4}>Basic Info</Title>
                                {this.state.basicInfoSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                            </Group>
                            <Divider color="blue" mt={4} mb={12} />
                            <Collapse in={this.state.basicInfoSection}>
                                <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Company</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.tenant_name}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Manufacturer</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.manufacturer_name}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Asset Name</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.name_of_asset}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Category</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.asset_category_name}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Type</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.asset_type_name}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Model</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.model_name}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Impact Level</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.impact}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>End of Life Date</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.end_of_life}</Table.Td>
                                    </Table.Tr>
                                </Table>
                            </Collapse>
                        </>
                        <>
                            <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('assignmentsSection')}>
                                <Title order={4}>Assignments</Title>
                                {this.state.assignmentsSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                            </Group>
                            <Divider color="blue" mt={4} mb={12} />
                            <Collapse in={this.state.assignmentsSection}>
                                <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Assigned To</Table.Td>
                                        <Table.Td c="blue">
                                            {
                                                this.state.asset.first_name !== null && this.state.asset.last_name !== null ?
                                                this.state.asset.middle_name !== null ?
                                                `${this.state.asset.first_name} ${this.state.asset.middle_name} ${this.state.asset.last_name}`
                                                :
                                                `${this.state.asset.first_name} ${this.state.asset.last_name}`
                                                :
                                                ""
                                            }
                                        </Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Assigned On</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.date_assigned}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Assigned Site</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.name_of_site}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Physical Location</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.physical_location}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Further Location Description</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.location_description}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Department Assigned</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.name_of_department}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Managing Group</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.managing_group_name}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Managing Person</Table.Td>
                                        <Table.Td c="blue">
                                            {
                                                this.state.asset.manager_first_name !== null && this.state.asset.manager_last_name !== null ?
                                                this.state.asset.manager_middle_name !== null ?
                                                `${this.state.asset.manager_first_name} ${this.state.asset.manager_middle_name} ${this.state.asset.manager_last_name}`
                                                :
                                                `${this.state.asset.manager_first_name} ${this.state.asset.manager_last_name}`
                                                :
                                                ""
                                            }
                                        </Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>AD OU</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.ad_ou}</Table.Td>
                                    </Table.Tr>
                                </Table>
                            </Collapse>
                        </>
                        <>
                            <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('identifyingDetailsSection')}>
                                <Title order={4}>Identifying Details</Title>
                                {this.state.identifyingDetailsSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                            </Group>
                            <Divider color="blue" mt={4} mb={12} />
                            <Collapse in={this.state.identifyingDetailsSection}>
                                <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Asset Tag</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.asset_tag}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Serial Number</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.asset_serial_number}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Bar Code</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.asset_bar_code}</Table.Td>
                                    </Table.Tr>
                                </Table>
                            </Collapse>
                        </>
                        <>
                            <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('purchaseInfoSection')}>
                                <Title order={4}>Purchase Info</Title>
                                {this.state.purchaseInfoSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                            </Group>
                            <Divider color="blue" mt={4} mb={12} />
                            <Collapse in={this.state.purchaseInfoSection}>
                                <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Vendor</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.vendor_name}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Purchase Date</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.acquisition_date}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Contract Number</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.contract_number}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Quote Status</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.quote_status}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Renewal Status</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.renewal_status}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Manufacturer Website</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.manufacturer_website}</Table.Td>
                                    </Table.Tr>
                                </Table>
                            </Collapse>
                        </>

                        {type === "Services" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('servicesSection')}>
                                    <Title order={4}>Services</Title>
                                    {this.state.servicesSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.servicesSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Health</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.health}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>SLA Availability %</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.sla_availability}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Cost</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cost}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Service Support Hours</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.service_support_hours}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {(type === "Cloud" ||
                            type === "Virtual Machine" ||
                            type === "Volume" ||
                            type === "Host" ||
                            type === "Datacenter" ||
                            type === "Datastore" ||
                            type === "Image" ||
                            type === "Load Balancer" ||
                            type === "Security Group" ||
                            type === "Network" ||
                            type === "Resource Pool" ||
                            type === "Network Interface" ||
                            type === "Public IP Address" ||
                            type === "VPC" ||
                            type === "Subnet" ||
                            type === "Database" ||
                            type === "Key Pair" ||
                            type === "Object Storage" ||
                            type === "Key Vault" ||
                            type === "Subscription" ||
                            type === "Resource Group" ||
                            type === "Application Gateway") && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('cloudSection')}>
                                    <Title order={4}>Cloud</Title>
                                    {this.state.cloudSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.cloudSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Cost</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cloud_cost}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Last Audit Date</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cloud_last_audit_date}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Region</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cloud_region}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Availability Zone</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cloud_availability_zone}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Provider</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.provider}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Virtual Machine" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('virtualMachineSection')}>
                                    <Title order={4}>Virtual Machine</Title>
                                    {this.state.virtualMachineSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.virtualMachineSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Instance Type</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.instance_type}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Private Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.private_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.public_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.vm_state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>OS Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.os_name}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Volume" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('volumeSection')}>
                                    <Title order={4}>Volume</Title>
                                    {this.state.volumeSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.volumeSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Volume Type</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.volume_type}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Size - GB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.size}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.volume_state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>IOPS</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.iops}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Creation Timestamp</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.creation_timestamp}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Host" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('hostSection')}>
                                    <Title order={4}>Host</Title>
                                    {this.state.hostSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.hostSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Memory Size - GB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.memory_size}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Average Memory Utilization</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.average_memory_utilization !== null ? 
                                                `${this.state.asset.average_memory_utilization} (${this.state.asset.average_memory_utilization_percent}%)` : undefined
                                            }</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>CPU</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cpu}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>CPU Core Count</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cpu_core_count}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Average Processor Utilization</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.average_processor_utilization}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Total Disk Size - GB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.total_disk_size}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Disk in Use</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.disk_in_use !== null ? 
                                                `${this.state.asset.disk_in_use} (${this.state.asset.disk_in_use_percent}%)` : undefined
                                            }</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Drive Encryption Status</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.drive_encryption_status}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.host_state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Internal IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.internal_ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Creation Timestamp</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.host_created_time}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Datacenter" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('datacenterSection')}>
                                    <Title order={4}>Datacenter</Title>
                                    {this.state.datacenterSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.datacenterSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.datacenter_state}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Datastore" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('datastoreSection')}>
                                    <Title order={4}>Datastore</Title>
                                    {this.state.datastoreSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.datastoreSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.datastore_state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Size - GB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.size}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Free Space</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.free_space}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Connection State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.connection_state}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Image" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('imageSection')}>
                                    <Title order={4}>Image</Title>
                                    {this.state.imageSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.imageSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Image Source</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.image_source}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Guest OS</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.guest_os}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Load Balancer" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('loadBalancerSection')}>
                                    <Title order={4}>Load Balancer</Title>
                                    {this.state.loadBalancerSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.loadBalancerSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>DNS Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.dns_name}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Security Group" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('securityGroupSection')}>
                                    <Title order={4}>Security Group</Title>
                                    {this.state.securityGroupSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.securityGroupSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Inbound Rule Count</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.inbound_rule_count}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Outbound Rule Count</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.outbound_rule_count}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Network" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('networkSection')}>
                                    <Title order={4}>Network</Title>
                                    {this.state.networkSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.networkSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.network_state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Connection State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.network_connection_state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Bandwidth</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.bandwidth}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Network Range</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.network_range}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Resource Pool" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('resourcePoolSection')}>
                                    <Title order={4}>Resource Pool</Title>
                                    {this.state.resourcePoolSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.resourcePoolSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.resource_pool_state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Last Updated</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.last_updated}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Network Interface" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('networkInterfaceSection')}>
                                    <Title order={4}>Network Interface</Title>
                                    {this.state.networkInterfaceSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.networkInterfaceSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>MAC Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.mac_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public DNS Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.public_dns_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Internal IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.internal_ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.network_interface_state}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Public IP Address" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('publicIPAddressSection')}>
                                    <Title order={4}>Public IP Address</Title>
                                    {this.state.publicIPAddressSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.publicIPAddressSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.public_ip}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.public_ip_state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public DNS</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.public_dns}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "VPC" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('vpcSection')}>
                                    <Title order={4}>VPC</Title>
                                    {this.state.vpcSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.vpcSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>CIDR Block</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cidr_block}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Subnet" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('subnetSection')}>
                                    <Title order={4}>Subnet</Title>
                                    {this.state.subnetSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.subnetSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>CIDR Block</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cidr_block}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Database" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('databaseSection')}>
                                    <Title order={4}>Database</Title>
                                    {this.state.databaseSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.databaseSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Port</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.database_port}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Engine Version</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.engine_version}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Allocated Storage - GiB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.allocated_storage}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Max Allocated Storage - GiB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.max_allocated_storage}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Endpoint</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.endpoint}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Created Time</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.created_time}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Multiple Availability Zone</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.multiple_availability_zone === 0 ? "No" : "Yes"}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>License Model</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.license_model}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Database Class</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.database_class}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Status</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.database_status}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Key Pair" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('keyPairSection')}>
                                    <Title order={4}>Key Pair</Title>
                                    {this.state.keyPairSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.keyPairSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Object Storage" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('objectStorageSection')}>
                                    <Title order={4}>Object Storage</Title>
                                    {this.state.objectStorageSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.objectStorageSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Key Vault" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('keyVaultSection')}>
                                    <Title order={4}>Key Vault</Title>
                                    {this.state.keyVaultSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.keyVaultSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Subscription" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('subscriptionSection')}>
                                    <Title order={4}>Subscription</Title>
                                    {this.state.subscriptionSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.subscriptionSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Resource Group" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('resourceGroupSection')}>
                                    <Title order={4}>Resource Group</Title>
                                    {this.state.resourceGroupSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.resourceGroupSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Application Gateway" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('applicationGatewaySection')}>
                                    <Title order={4}>Application Gateway</Title>
                                    {this.state.applicationGatewaySection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.applicationGatewaySection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item ID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_id}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Item Name</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.item_name}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {(type === "Hardware" ||
                            type === "Computer" ||
                            type === "Desktop" ||
                            type === "Laptop" ||
                            type === "Server" ||
                            type === "Storage" ||
                            type === "Disk" ||
                            type === "Datacenter" ||
                            type === "Rack" ||
                            type === "UPS" ||
                            type === "Mobile Devices" ||
                            type === "Monitor" ||
                            type === "Printer" ||
                            type === "Projector" ||
                            type === "Scanner" ||
                            type === "Router" ||
                            type === "Switch" ||
                            type === "Access Point" ||
                            type === "Firewall" ||
                            type === "Other Devices" ||
                            type === "SNMP") && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('hardwareSection')}>
                                    <Title order={4}>Hardware</Title>
                                    {this.state.hardwareSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.hardwareSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Usage Type</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.usage_type}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Domain</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.domain}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Connection Types</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.connection_types}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Asset State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Last Audit Date</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.last_audit_date}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {(type === "Hardware" ||
                            type === "Computer" ||
                            type === "Desktop" ||
                            type === "Laptop" ||
                            type === "Server" ||
                            type === "Storage" ||
                            type === "Disk" ||
                            type === "Datacenter" ||
                            type === "Rack" ||
                            type === "UPS" ||
                            type === "Mobile Devices" ||
                            type === "Monitor" ||
                            type === "Printer" ||
                            type === "Projector" ||
                            type === "Scanner" ||
                            type === "Router" ||
                            type === "Switch" ||
                            type === "Access Point" ||
                            type === "Firewall" ||
                            type === "Other Devices" ||
                            type === "SNMP") && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('costSection')}>
                                    <Title order={4}>Cost</Title>
                                    {this.state.costSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.costSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Cost</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cost}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Salvage</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.salvage}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Depreciation Type</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.depreciation_type}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {(type === "Computer" ||
                            type === "Desktop" ||
                            type === "Laptop" ||
                            type === "Server") && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('computerSection')}>
                                    <Title order={4}>Computer</Title>
                                    {this.state.computerSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.computerSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>OS</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.os_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>OS Version</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.os_version}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>OS Build</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.os_build}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>OS Service Pack</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.os_service_pack}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Memory - GB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.memory}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Average Memory Utilization</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.average_memory_utilization !== null ? 
                                                `${this.state.asset.average_memory_utilization} (${this.state.asset.average_memory_utilization_percent}%)` : undefined 
                                            }</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Disk Space - GB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.computer_disk_space}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Disk in Use</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.disk_in_use !== null ? 
                                                `${this.state.asset.disk_in_use} (${this.state.asset.disk_in_use_percent}%)` : undefined 
                                            }</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Drive Encryption Status</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.drive_encryption_status}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>CPU</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cpu}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>CPU Speed - GHz</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cpu_speed}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>CPU Core Count</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.cpu_core_count}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Average Processor Utilization</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.average_processor_utilization}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>MAC Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.mac_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>UUID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.uuid}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Hostname</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.hostname}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Internal IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.internal_ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Last Login By</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.last_login_by}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Last Login Timestamp</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.last_login_timestamp}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Disk" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('diskSection')}>
                                    <Title order={4}>Disk</Title>
                                    {this.state.diskSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.diskSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Drive Type</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.drive_type}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Disk Space - GB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.disk_space}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Disk in Use</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.disk_in_use !== null ?
                                                `${this.state.asset.disk_in_use} (${this.state.asset.disk_in_use_percent}%)` : undefined
                                            }</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Free Space - GB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.disk_free_space}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Free Space Checked On</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.free_space_checked_on}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Drive Encryption Status</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.drive_encryption_status}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Rack" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('rackSection')}>
                                    <Title order={4}>Rack</Title>
                                    {this.state.rackSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.rackSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Footprint</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.footprint}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Power Consumption</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.power_consumption}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Rack Units</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.rack_units}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Rack Units In Use</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.rack_units_in_use}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "UPS" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('upsSection')}>
                                    <Title order={4}>UPS</Title>
                                    {this.state.upsSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.upsSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Internal IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.internal_ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Battery Status</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.battery_status}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Battery Voltage</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.battery_voltage}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Battery Current</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.battery_current}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Mobile Devices" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('mobileDevicesSection')}>
                                    <Title order={4}>Mobile Devices</Title>
                                    {this.state.mobileDevicesSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.mobileDevicesSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>OS</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.os_name}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>OS Version</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.os_version}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>OS Build</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.os_build}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Memory - GB</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.memory}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Average Memory Utilization</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.average_memory_utilization !== null ? 
                                                `${this.state.asset.average_memory_utilization} (${this.state.asset.average_memory_utilization_percent}%)` : undefined
                                            }</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>IMEI Number</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.imei_number}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Printer" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('printerSection')}>
                                    <Title order={4}>Printer</Title>
                                    {this.state.printerSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.printerSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Printer Type</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.printer_type}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Internal IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.internal_ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>MAC Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.mac_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Subnet Mask</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.subnet_mask}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Router" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('routerSection')}>
                                    <Title order={4}>Router</Title>
                                    {this.state.routerSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.routerSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Firmware</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.firmware}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Firmware Version</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.firmware_version}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Internal IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.internal_ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Ports</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.port}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>MAC Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.mac_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Subnet Mask</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.subnet_mask}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Switch" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('switchSection')}>
                                    <Title order={4}>Switch</Title>
                                    {this.state.switchSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.switchSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Firmware</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.firmware}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Firmware Version</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.firmware_version}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Internal IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.internal_ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Ports</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.port}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>MAC Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.mac_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Subnet Mask</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.subnet_mask}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Access Point" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('accessPointSection')}>
                                    <Title order={4}>Access Point</Title>
                                    {this.state.accessPointSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.accessPointSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Firmware</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.firmware}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Firmware Version</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.firmware_version}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Internal IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.internal_ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Ports</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.port}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>MAC Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.mac_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Subnet Mask</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.subnet_mask}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Firewall" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('firewallSection')}>
                                    <Title order={4}>Firewall</Title>
                                    {this.state.firewallSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.firewallSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Firmware</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.firmware}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Firmware Version</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.firmware_version}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Public IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Internal IP Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.internal_ip_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Ports</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.port}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>MAC Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.mac_address}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Subnet Mask</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.subnet_mask}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "SNMP" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('snmpSection')}>
                                    <Title order={4}>SNMP</Title>
                                    {this.state.snmpSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.snmpSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>System OID</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.system_oid}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>MAC Address</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.mac_address}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Consumable" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('consumableSection')}>
                                    <Title order={4}>Consumable</Title>
                                    {this.state.consumableSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.consumableSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>State</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.consumable_state}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Quantity</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.quantity}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        {type === "Document" && (
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('documentSection')}>
                                    <Title order={4}>Document</Title>
                                    {this.state.documentSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.documentSection}>
                                    <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Status</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.document_status}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Type</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.document_type}</Table.Td>
                                        </Table.Tr>
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Version</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.version}</Table.Td>
                                        </Table.Tr>
                                    </Table>
                                </Collapse>
                            </>
                        )}

                        <>
                            <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('warrantyLeaseandMaintenanceSection')}>
                                <Title order={4}>Warranty Lease and Maintenance</Title>
                                {this.state.warrantyLeaseandMaintenanceSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                            </Group>
                            <Divider color="blue" mt={4} mb={12} />
                            <Collapse in={this.state.warrantyLeaseandMaintenanceSection}>
                                <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Warranty Start Date</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.warranty_start_date}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Warranty End Date</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.warranty_expiration_date}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Lease Start Date</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.lease_start_date}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Lease End Date</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.lease_end_date}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Maintenance Dates</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.maintenance_dates}</Table.Td>
                                    </Table.Tr>
                                </Table>
                            </Collapse>
                        </>
                        <>
                            <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('miscSection')}>
                                <Title order={4}>Misc</Title>
                                {this.state.miscSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                            </Group>
                            <Divider color="blue" mt={4} mb={12} />
                            <Collapse in={this.state.miscSection}>
                                <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Asset Is Tracked</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.isTracked === 0 ? "No" : "Yes"}</Table.Td>
                                    </Table.Tr>
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Asset Is A Peripheral</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.is_peripheral === 0 ? "No" : "Yes"}</Table.Td>
                                    </Table.Tr>
                                    {this.state.asset.is_peripheral === 1 &&
                                        <Table.Tr>
                                            <Table.Td style={{width: "20%"}}>Asset Assigned To</Table.Td>
                                            <Table.Td c="blue">{this.state.asset.core_asset_assigned_to_name}</Table.Td>
                                        </Table.Tr>
                                    }
                                    <Table.Tr>
                                        <Table.Td style={{width: "20%"}}>Description</Table.Td>
                                        <Table.Td c="blue">{this.state.asset.description}</Table.Td>
                                    </Table.Tr>
                                </Table>
                            </Collapse>
                        </>
                        <>
                            <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('attachmentsSection')}>
                                <Title order={4}>Attachments</Title>
                                {this.state.attachmentsSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                            </Group>
                            <Divider color="blue" mt={4} mb={12} />
                            <Collapse in={this.state.attachmentsSection}>
                                <Table withRowBorders={false} style={{cursor: "default", marginBottom: "30px"}}>
                                    {this.state.attachments && this.state.attachments.map((attachment) => (
                                        <Table.Tr>
                                            <Anchor href={attachment.attachment_url} target="_blank">{attachment.filename}</Anchor>
                                        </Table.Tr>
                                    ))}
                                </Table>
                            </Collapse>
                        </>
                        <>
                            <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('notesSection')}>
                                <Title order={4}>Notes</Title>
                                {this.state.notesSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                            </Group>
                            <Divider color="blue" mt={4} mb={12} />
                            <Collapse in={this.state.notesSection}>
                                <div style={{"marginLeft": '10px', "marginBottom": '10px'}}><Button onClick={() => this.openAssetNotesModal()}>Add +</Button></div>
                                <Table withRowBorders={true} style={{cursor: "default", marginBottom: "30px"}}>
                                    <Table.Thead>
                                        <Table.Th w='68%'>Note Text</Table.Th>
                                        <Table.Th w='20%'>Created By</Table.Th>
                                        <Table.Th w='12%'>Time Created</Table.Th>
                                    </Table.Thead>
                                    <Table.Tbody>
                                        {this.state.notes && this.state.notes.map((note) => (
                                            <Table.Tr>
                                                <Table.Td w='68%'>{parse(cleanHTML(note.note_text))}</Table.Td>
                                                <Table.Td w='20%'>{`${note.creator_first_name} ${note.creator_last_name}`}</Table.Td>
                                                <Table.Td w='12%'>{note.formatted_date_time_created}</Table.Td>
                                            </Table.Tr>
                                        ))}
                                    </Table.Tbody>
                                </Table>
                            </Collapse>
                        </>
                        {this.state.installed_software && this.state.installed_software.length > 0 ?
                            <>
                                <Group style={{cursor: "pointer"}} onClick={() => this.toggleSection('installedSoftwareSection')}>
                                    <Title order={4}>Installed Software</Title>
                                    {this.state.installedSoftwareSection ? <IconChevronDown size={20} stroke={1.5} /> : <IconChevronUp size={20} stroke={1.5} />}
                                </Group>
                                <Divider color="blue" mt={4} mb={12} />
                                <Collapse in={this.state.installedSoftwareSection}>
                                    <Table style={{cursor: "default", marginBottom: "30px"}}>
                                        <Table.Thead>
                                            <Table.Tr>
                                                <Table.Th style={{width: "50%"}}>Name</Table.Th>
                                                <Table.Th style={{width: "25%"}}>Vendor</Table.Th>
                                                <Table.Th style={{width: "25%"}}>Version</Table.Th>
                                            </Table.Tr>
                                        </Table.Thead>
                                        <Table.Tbody>
                                            {/* {this.state.further_device_details.software_list && 
                                            [...this.state.further_device_details.software_list]
                                                .sort((a, b) => {
                                                    const nameA = a.name ? a.name.toLowerCase() : "";
                                                    const nameB = b.name ? b.name.toLowerCase() : "";
                                                    return nameA.localeCompare(nameB);
                                                }) */}
                                            {this.state.installed_software && this.state.installed_software.map((item, index) => (
                                                (item.name !== null && item.vendor !== null && item.version !== null) ? (
                                                    <Table.Tr key={`softwareRow-${index}`}>
                                                        <Table.Td style={{width: "50%"}}>{item.name !== null ? item.name : "-"}</Table.Td>
                                                        <Table.Td style={{width: "25%"}}>{item.vendor !== null ? item.vendor : "-"}</Table.Td>
                                                        <Table.Td style={{width: "25%"}}>{item.version !== null ? item.version : "-"}</Table.Td>
                                                    </Table.Tr>
                                                ) : undefined 
                                            ))}
                                        </Table.Tbody>
                                    </Table>
                                </Collapse>
                            </>
                            :
                            undefined
                        }
                    </Paper>
                    {/* <Row>
                        <Col md={{span: 8, offset: 2}}>
                            <Button onClick={() => this.goToEditPage()}>Edit</Button>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                            <Col md={{span: 4, offset: 2}}>
                                <Card style={{flex: "1", height: "300px"}}>
                                    <Card.Header style={{color: "white", textAlign: "center", backgroundColor: "#343a40"}} className="gothamNarrowFont">Basic Details</Card.Header>
                                    <Card.Body>                  
                                        <div style={{height: "190px", overflow: "auto"}}>
                                            <Table striped>
                                                <tbody>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Asset Name</td>
                                                        {this.state.asset.name_of_asset && this.state.asset.name_of_asset !== "" ?
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.name_of_asset}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Category</td>
                                                        {this.state.asset.asset_category_name && this.state.asset.asset_category_name !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.asset_category_name}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Type</td>
                                                        {this.state.asset.asset_type_name && this.state.asset.asset_type_name !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.asset_type_name}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Model</td>
                                                        {this.state.asset.model_name && this.state.asset.model_name !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.model_name}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Acquisition Date</td>
                                                        {this.state.asset.acquisition_date && this.state.asset.acquisition_date !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.acquisition_date.split("T")[0]}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Tag</td>
                                                        {this.state.asset.asset_tag && this.state.asset.asset_tag !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.asset_tag}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Barcode</td>
                                                        {this.state.asset.asset_bar_code && this.state.asset.asset_bar_code !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.asset_bar_code}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Serial Number</td>
                                                        {this.state.asset.asset_serial_number && this.state.asset.asset_serial_number !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.asset_serial_number}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">IP Address</td>
                                                        {this.state.asset.ip_address && this.state.asset.ip_address !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.ip_address}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">MAC Address</td>
                                                        {this.state.asset.mac_address && this.state.asset.mac_address !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.mac_address}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">CPU</td>
                                                        {this.state.asset.cpu && this.state.asset.cpu !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.cpu}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">RAM</td>
                                                        {this.state.asset.ram && this.state.asset.ram !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.ram}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Manufacturer Website</td>
                                                        {this.state.asset.manufacturer_website && this.state.asset.manufacturer_website !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.manufacturer_website}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Vendor Name</td>
                                                        {this.state.asset.vendor_name && this.state.asset.vendor_name !== "" ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.vendor_name}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Is Tracked Asset</td>
                                                        {this.state.asset.isTracked !== null && this.state.asset.isTracked ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">Yes</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">No</td>
                                                        }
                                                    </tr>
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col md={{span: 4}}>
                                <Card style={{flex: "1", height: "300px"}}>
                                    <Card.Header style={{color: "white", textAlign: "center", backgroundColor: "#343a40"}} className="gothamNarrowFont">Assignment / Location</Card.Header>
                                    <Card.Body>                  
                                        <div style={{height: "190px", overflow: "auto"}}>
                                            <Table striped>
                                                <tbody>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Assigned To</td>
                                                        {this.state.asset.assigned_person_id && this.state.asset.assigned_person_id !== null && this.state.asset.middle_name !== null ?
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{`${this.state.asset.first_name} ${this.state.asset.middle_name} ${this.state.asset.last_name}`}</td>
                                                            :
                                                            this.state.asset.assigned_person_id && this.state.asset.assigned_person_id !== null && this.state.asset.middle_name === null ?
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{`${this.state.asset.first_name} ${this.state.asset.last_name}`}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">Unassigned</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Company</td>
                                                        {this.state.asset.tenant_name && this.state.tenant_name !== "" ?
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.tenant_name}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Site</td>
                                                        {this.state.asset.name_of_site && this.state.asset.name_of_site !== "" ?
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.name_of_site}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    <tr>
                                                        <td style={{width: "50%"}} className="gothamNarrowLightFont">Location at Site</td>
                                                        {this.state.asset.assigned_location_at_site_id && this.state.asset.assigned_location_at_site_id !== null ? 
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{`Floor(${this.state.asset.floor_number}) Aisle(${this.state.asset.aisle_number}) Desk(${this.state.asset.desk_number})`}</td>
                                                            :
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                        }
                                                    </tr>
                                                    {this.state.asset.core_asset_assigned_to_id && this.state.asset.core_asset_assigned_to_id !== null ?
                                                        <tr>
                                                            <td style={{width: "50%"}} className="gothamNarrowLightFont">Core Asset Assigned To</td>
                                                            <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.core_asset_assigned_to_name}</td>
                                                        </tr>
                                                        :
                                                        undefined
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>      
                    </Row>
                    <Row className="mt-4">
                        <Col md={{span: 4, offset: 2}}>
                            <Card style={{flex: "1", height: "300px"}}>
                                <Card.Header style={{color: "white", textAlign: "center", backgroundColor: "#343a40"}} className="gothamNarrowFont">Warranty / Lease</Card.Header>
                                <Card.Body>                  
                                    <div style={{height: "190px", overflow: "auto"}}>
                                        <Table striped>
                                            <tbody>
                                                <tr>
                                                    <td style={{width: "50%"}} className="gothamNarrowLightFont">Warranty Start Date</td>
                                                    {this.state.asset.warranty_start_date && this.state.asset.warranty_start_date !== null ? 
                                                        <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.warranty_start_date.split("T")[0]}</td>
                                                        :
                                                        <td style={{width: "50%", color: "red"}} className="gothamNarrowFont">None Active</td>
                                                    }
                                                </tr>
                                                <tr>
                                                    <td style={{width: "50%"}} className="gothamNarrowLightFont">Warranty End Date</td>
                                                    {this.state.asset.warranty_expiration_date && this.state.asset.warranty_expiration_date !== null ? 
                                                        <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.warranty_expiration_date.split("T")[0]}</td>
                                                        :
                                                        <td style={{width: "50%", color: "red"}} className="gothamNarrowFont">None Active</td>
                                                    }
                                                </tr>
                                                <tr>
                                                    <td style={{width: "50%"}} className="gothamNarrowLightFont">Warranty Days Remaining</td>
                                                    {this.state.warranty_days_remaining !== null && this.state.warranty_days_remaining <= 0 ?
                                                        <td style={{width: "50%", color: "red"}} className="gothamNarrowFont">0</td>
                                                        :
                                                        this.state.warranty_days_remaining !== null && this.state.warranty_days_remaining <= 30 ? 
                                                        <td style={{width: "50%", color: "orangered"}} className="gothamNarrowFont">{this.state.warranty_days_remaining}</td>
                                                        :
                                                        this.state.warranty_days_remaining !== null && this.state.warranty_days_remaining > 30 ?
                                                        <td style={{width: "50%", color: "green"}} className="gothamNarrowFont">{this.state.warranty_days_remaining}</td>
                                                        :
                                                        <td style={{width: "50%", color: "red"}} className="gothamNarrowFont">None Active</td>
                                                    }
                                                </tr>
                                                <tr>
                                                    <td style={{width: "50%"}} className="gothamNarrowLightFont">Lease Start Date</td>
                                                    {this.state.asset.lease_start_date && this.state.asset.lease_start_date !== null ?
                                                        <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.lease_start_date.split("T")[0]}</td>
                                                        :
                                                        <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                    }
                                                </tr>
                                                <tr>
                                                    <td style={{width: "50%"}} className="gothamNarrowLightFont">Lease End Date</td>
                                                    {this.state.asset.lease_end_date && this.state.asset.lease_end_date !== null ? 
                                                        <td style={{width: "50%"}} className="gothamNarrowFont">{this.state.asset.lease_end_date.split("T")[0]}</td>
                                                        :
                                                        <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                    }
                                                </tr>
                                                <tr>
                                                    <td style={{width: "50%"}} className="gothamNarrowLightFont">Lease Days Remaining</td>
                                                    {this.state.lease_days_remaining !== null && this.state.lease_days_remaining <= 0 ?
                                                        <td style={{width: "50%", color: "red"}} className="gothamNarrowFont">0</td>
                                                        :
                                                        this.state.lease_days_remaining !== null && this.state.lease_days_remaining <= 30 ? 
                                                        <td style={{width: "50%", color: "orangered"}} className="gothamNarrowFont">{this.state.lease_days_remaining}</td>
                                                        :
                                                        this.state.lease_days_remaining !== null && this.state.lease_days_remaining > 30 ?
                                                        <td style={{width: "50%", color: "green"}} className="gothamNarrowFont">{this.state.lease_days_remaining}</td>
                                                        :
                                                        <td style={{width: "50%"}} className="gothamNarrowFont">-</td>
                                                    }
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={{span: 4}}>
                            <Card style={{flex: "1", height: "300px"}}>
                                <Card.Header style={{color: "white", textAlign: "center", backgroundColor: "#343a40"}} className="gothamNarrowFont">
                                    History
                                    <span style={{display: "inline-block", paddingLeft: "15px"}}>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip>Click to add a new item</Tooltip>
                                            }
                                        >
                                            <FontAwesomeIcon style={{color: "white", cursor: "pointer", fontSize: "10pt"}} icon={faPlus} onClick={() => this.openHistoryNoteModal()}/>
                                        </OverlayTrigger>
                                    </span>
                                </Card.Header>
                                <Card.Body>                  
                                    <div style={{height: "190px", overflow: "auto"}}>
                                        <Table striped hover className="hardwareAssetTable">
                                            <tbody>
                                                {this.state.history && this.state.history.map((item) => (
                                                    <tr key={`historyItem${item.id}`} onClick={() => this.openHistoryNoteDetailsModal(item.id)}>
                                                        <td style={{width: "25%"}} className="gothamNarrowLightFont">{item.date_time_created.split(" ")[0]}</td>
                                                        <td style={{width: "75%"}} className="gothamNarrowFont">
                                                            {item.is_user_created ? 
                                                                `[Note] ${item.item_text}`
                                                                :
                                                                `${item.item_text}`
                                                            }
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>      
                    </Row> */}      
                </Container>

                {/* This modal is for the create asset note form */}
                <Modal
                    opened={this.state.show_notes_modal}
                    onClose={() => this.closeAssetNotesModal()}
                    title="Create Asset Note"
                    size="xl"
                    centered
                >
                    <Modal.Body>
                        <div>
                            <Form>
                                <Form.Row>
                                    <Form.Group as={Col} controlId="assetNotesFormInput">
                                        <Form.Label>Note Text</Form.Label>
                                        <div data-text-editor="name">
                                            <RichTextInput defaultValue={this.state.asset_note_text_input} onChange={e => this.onChangeAssetNote(e)} />
                                        </div>
                                    </Form.Group>
                                </Form.Row>
                            </Form>
                            <div style={{textAlign: 'center', marginTop: "50px"}}>
                                <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => this.closeAssetNotesModal()}>Cancel</Button></span>
                                <span>
                                    {this.state.asset_note_text_input && this.state.asset_note_text_input !== "<p></p>" && this.state.asset_note_text_input.length > 0 ?
                                        <Button color="blue" onClick={() => this.submitAssetNote()}>Submit</Button>
                                        :
                                        <Button color="blue" disabled>Submit</Button>
                                    }
                                </span>
                            </div>
                        </div>
                    </Modal.Body>
                    
                </Modal>


                {/* This modal is for the loading screen */}
                <Modal
                    opened={this.state.showSaving}
                    onClose={() => { this.setState({ showSaving: false }) }}
                    size="xl"
                    centered
                    withCloseButton={false}
                >


                    <Modal.Body>
                        <div className="gothamNarrowLightFont" style={{ cursor: "default", textAlign: "center" }}>Saving... Please wait.</div>
                    </Modal.Body>

                </Modal>


                {/* This modal is for the add history note form - NOT IN USE */}
                {/* <Modal
                    show={this.state.show_history_note_modal}
                    onHide={() => this.closeHistoryNoteModal()}
                    backdrop="static"
                    keyboard={false}
                    size="lg"
                    centered
                >
                    <Form>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <div style={{textAlign: "center", cursor: "default"}} className="gothamNarrowFont">Create History Note</div>
                                <div style={{cursor: "default", fontSize: "15px"}} className="gothamNarrowLightFont"><span className="requiredStar">*</span> indicates a required field</div>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div style={{width: "100%"}}>
                                <span style={{display: "inline-block", width: "90%"}}>
                                    <Form.Group controlId="addHistoryNoteText" className="mb-3">
                                        <Form.Label>Note Text<span className="requiredStar">*</span></Form.Label>
                                        <Form.Control type="text" placeholder="ex: Deployed Software..." required value={this.state.history_note_text_entered} onChange={this.handleCreateHistoryNoteTextChange}/>
                                    </Form.Group>
                                </span>
                                <span style={{display: "inline-block", width: "90%"}}>
                                                <Form.Group controlId="addHistoryNoteType" className="mb-3">
                                                    <Form.Label>Event Type<span className="requiredStar">*</span></Form.Label>
                                                    <Form.Control as="select" required>
                                                        {this.state.eventTypes && this.state.eventTypes.map((type) => (
                                                            <>
                                                                {this.state.selected_event_type_name === type.event_type_name ?
                                                                    <option key={`eventName_${type.event_type_name}`} onClick={() => this.handleSelectedEventTypeChange(type.event_type_name)} selected>{type.event_type_name}</option>
                                                                    :
                                                                    <option key={`eventName_${type.event_type_name}`} onClick={() => this.handleSelectedEventTypeChange(type.event_type_name)}>{type.event_type_name}</option>
                                                                }
                                                            </>
                                                        ))}
                                                    </Form.Control>
                                                </Form.Group>
                                            </span>
                            </div>
                            <div style={{textAlign: "center", marginTop: "15px"}}>
                                {this.state.canSeeErrorMessageCreateHistoryNote ?
                                <p style={{color: "red"}}>Error: One or more required form fields has not been filled out. Please complete required fields.</p>
                                :
                                undefined
                                }
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div style={{paddingRight: "15px"}}>
                                <Button variant="secondary" onClick={() => this.closeHistoryNoteModal()} className="gothamNarrowFont">Cancel</Button>
                            </div>
                            <div>     
                                <Button id="newDepartmentFormOkButton" onClick= {() => {this.submitCreateHistoryNoteForm()}} className="gothamNarrowFont">Submit</Button>
                            </div>
                        </Modal.Footer>
                    </Form>
                </Modal> */}

                {/* This modal is for the history note details when user clicks a note in history table - NOT IN USE */}
                {/* <Modal
                    show={this.state.show_history_note_details_modal}
                    onHide={() => this.closeHistoryNoteDetailsModal()}
                    backdrop="static"
                    keyboard={false}
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <div style={{textAlign: "center", cursor: "default"}} className="gothamNarrowFont">History Event Details</div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                            <p>
                                {this.state.note_details.is_user_created && this.state.note_details.middle_name && this.state.note_details.middle_name !== null ?
                                    <span><span className="gothamNarrowLightFont">Initiated By: </span> <span style={{marginLeft: "25px"}} className="gothamNarrowFont">{`${this.state.note_details.first_name} ${this.state.note_details.middle_name} ${this.state.note_details.last_name}`}</span></span>
                                    :
                                    this.state.note_details.is_user_created && this.state.note_details.middle_name === null ?
                                    <span><span className="gothamNarrowLightFont">Initiated By: </span><span style={{marginLeft: "25px"}} className="gothamNarrowFont">{`${this.state.note_details.first_name} ${this.state.note_details.last_name}`}</span></span>
                                    :
                                    <span><span className="gothamNarrowLightFont">Initiated By: </span><span style={{marginLeft: "25px"}} className="gothamNarrowFont">Auto Generated By System</span></span>
                                }
                            </p>
                            <p>
                                {this.state.note_details.date_time_created && this.state.note_details.date_time_created !== null ?
                                    <span><span className="gothamNarrowLightFont">Time: </span><span style={{marginLeft: "25px"}} className="gothamNarrowFont">{`${this.state.note_details.date_time_created.split(" ")[0]}`}</span> <span style={{marginLeft: "25px"}} className="gothamNarrowFont">{`${this.state.note_details.date_time_created.split(" ")[1].split(".")[0]}`}</span></span>
                                    :
                                    undefined
                                }
                            </p>
                            <p>
                                {this.state.note_details.item_type && this.state.note_details.item_type !== null ? 
                                    <span><span className="gothamNarrowLightFont">Event Type: </span><span style={{marginLeft: "25px"}} className="gothamNarrowFont">{`${this.state.note_details.item_type}`}</span></span>
                                    :
                                    undefined
                                }
                            </p>
                            <p>
                                {this.state.note_details.name_of_asset && this.state.note_details.name_of_asset !== null ?
                                    <span><span className="gothamNarrowLightFont">Asset Involved: </span><span style={{marginLeft: "25px"}} className="gothamNarrowFont">{`${this.state.note_details.name_of_asset}`}</span></span>
                                    :
                                    undefined
                                }
                            </p>
                            <p>
                                {this.state.note_details.item_text && this.state.note_details.item_text !== null ?
                                    <span><span className="gothamNarrowLightFont">Note: </span><span style={{marginLeft: "25px"}} className="gothamNarrowFont">{`${this.state.note_details.item_text}`}</span></span>
                                    :
                                    undefined
                                }
                            </p>
                    </Modal.Body>
                    <Modal.Footer>
                        <div>     
                            <Button id="newDepartmentFormOkButton" onClick= {() => this.closeHistoryNoteDetailsModal()} className="gothamNarrowFont">Ok</Button>
                        </div>
                    </Modal.Footer>
                </Modal> */}
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loggedStatus: state.logged,
        activeNavLinkStatus: state.activeNav,
        userPermissions: state.userPermissions
    };
}

export default connect(mapStateToProps, { LOGOUT })(HardwareAssetDetails);